/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FlexContainer, Heading } from "@nordcloud/gnui";
import logo from "../../assets/images/ninja.png";

export function Page404() {
  return (
    <FlexContainer>
      <img alt="logo" src={logo} css={{ width: "30rem", height: "auto" }} />
      <div>
        <div css={{ transform: "rotate(-15deg)" }}>
          <Heading level={1} mb={0} as="p">
            Ooooops
          </Heading>
          <Heading level={4} as="p">
            There is no such page :({" "}
          </Heading>

          <Heading level={2} as="p">
            Try search instead!{" "}
          </Heading>
        </div>
      </div>
    </FlexContainer>
  );
}
